module.exports = [{"type":"title","text":"2025-06-12"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續U本位：下單接口的返回增加executedQty字段。"},{"type":"html","text":"永續U本位：查詢單個訂單詳情和查詢所有委托中訂單的返回增加closePosition字段。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2025-06-12.json
// module id = BVW9
// module chunks = 3